import { Injectable } from '@angular/core';
import {
  DayView,
  DayViewHour,
  getDayView,
  GetDayViewArgs,
  getDayViewHourGrid,
  GetDayViewHourGridArgs,
  getMonthView,
  GetMonthViewArgs,
  getWeekView,
  GetWeekViewArgs,
  getWeekViewHeader,
  GetWeekViewHeaderArgs,
  MonthView,
  WeekDay,
  WeekView
} from 'calendar-utils';
import { DateAdapter } from '../../date-adapters/date-adapter';

@Injectable()
export class CalendarUtils {
  constructor(protected dateAdapter: DateAdapter) {}

  getMonthView(args: GetMonthViewArgs): MonthView {
    return getMonthView(this.dateAdapter, args);
  }

  getWeekViewHeader(args: GetWeekViewHeaderArgs): WeekDay[] {
    return getWeekViewHeader(this.dateAdapter, args);
  }

  getWeekView(args: GetWeekViewArgs): WeekView {
    return getWeekView(this.dateAdapter, args);
  }

  getDayView(args: GetDayViewArgs): DayView {
    return getDayView(this.dateAdapter, args);
  }

  getDayViewHourGrid(args: GetDayViewHourGridArgs): DayViewHour[] {
    return getDayViewHourGrid(this.dateAdapter, args);
  }
}
